import { z } from 'zod'

export const SystemCatalogItemStatusSchema = z.string().transform((value) => {
  switch (value) {
    case '0':
      return 'Inactive'
    case '1':
      return 'Active'
    default:
      throw new Error('Invalid item status values')
  }
})

export type SystemCatalogItemStatus = z.infer<
  typeof SystemCatalogItemStatusSchema
>

export const SystemCatalogCategoryTypeSchema = z.union([
  z.literal('Good'),
  z.literal('Service'),
  z.literal('N/A'),
])

export type SystemCatalogCategoryType = z.infer<
  typeof SystemCatalogCategoryTypeSchema
>

export const SystemCatalogItemSchema = z.object({
  id: z.number(),
  status: SystemCatalogItemStatusSchema,
  name: z.string(),
  created_at: z.string().nullable(),
  type_name: z.string(),
  updated_at: z.string().nullable(),
})
export type SystemCatalogItem = z.infer<typeof SystemCatalogItemSchema>

export const SystemCatalogCategorySchema = z.object({
  id: z.number(),
  status: SystemCatalogItemStatusSchema,
  name: z.string(),
  type: z.number().nullable(),
  type_name: SystemCatalogCategoryTypeSchema,
  created_at: z.string().nullable(),
  updated_at: z.string().nullable(),
  items: z.array(
    z.object({
      id: z.number(),
      name: z.string(),
    })
  ),
})

export type SystemCatalogCategory = z.infer<typeof SystemCatalogCategorySchema>
